/* eslint-disable */
import { useState } from "react";
import ProgramTable from "./components/tableprogram";
import { Title } from "@mantine/core";
import { PermissionButton } from "api/permission/buttonpermission";
import ProgramAddModal from "./components/AddOrgMembers";

export default function ProgramFeature() {
  const [opened, setOpened] = useState(false);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <Title order={3}>Programs</Title>

        <div>
          <PermissionButton
            permission="department.add"
            onClick={() => setOpened(true)}
          >
            Add program
          </PermissionButton>
        </div>
      </div>
      <ProgramTable />
      <ProgramAddModal opened={opened} onClose={() => setOpened(false)} />
    </div>
  );
}
